/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import LastUpdate from '../../components/LastUpdate';
import PoliticalParty from '../../components/PoliticalParty';
import PoliticalCandidate from '../../components/PoliticalCandidate';
import './InfoParty.scss';
import Resume from '../../components/Resume';
import axios from 'axios';
import converterTime from '../../components/LastUpdate/LastUpdate.utils';
import groupBy from 'array.prototype.groupby';
import { useSearchParams } from 'react-router-dom';

function InforParty() {
  let bulletinInitial = {
    bulletinGeneral: '00.000',
    deskTotal: '000.00',
    deskInformation: '00.000',
    desckScreened: '000.00',
  };

  const [coalitions, setCoalitions] = useState([]);
  const [votes, setVotes] = useState({});
  const [bulletin, setBulletin] = useState(bulletinInitial);
  const [time, setTime] = useState(null);
  const [seeMore, setSeeMore] = useState(false);
  groupBy.shim();

  const [searchParams] = useSearchParams({});
  const [lastUpdate, setLastUpdate] = useState(null);
  const [coalition, setCoalition] = useState(null);
  const [candidate, setCandidate] = useState(null);
  const [showMore, setShowMore] = useState(null);
  const [stats, setStats] = useState(null);
  const theme = searchParams.get('theme') || ''
  console.log('THEME info', theme)

  useEffect(() => {
    searchParams.get('lastUpdate') === 'true' ? setLastUpdate(true) : setLastUpdate(false);
    searchParams.get('coalition') === 'true' ? setCoalition(true) : setCoalition(false);
    searchParams.get('candidate') === 'true' ? setCandidate(true) : setCandidate(false);
    searchParams.get('showMore') === 'true' ? setShowMore(true) : setShowMore(false);
    searchParams.get('stats') === 'true' ? setStats(true) : setStats(false);
  }, []);

  useEffect(() => {
    candidate && setSeeMore(true);
  }, [lastUpdate, coalition, candidate, showMore, stats]);

  const getData = async () => {
    try {
      const resp = await axios.get('https://data-ecp.infobae.com/infobae.com/2022/colombia/paso/CO_delegates.json');
      let lastTimeUpdate = converterTime(resp.data.last_update);
      setTime(lastTimeUpdate);
      setVotes({
        votesTotal: new Intl.NumberFormat().format(resp.data.election.total_votes.qty),
        votesAnnulled: new Intl.NumberFormat().format(resp.data.stats[1].votes),
        votesBlank: new Intl.NumberFormat().format(resp.data.stats[0].votes),
        votesInvalid: new Intl.NumberFormat().format(resp.data.stats[2].votes),
      });

      let newarr = resp.data.parties.groupBy((e) => e.name);
      let formatedData = Object.keys(newarr).map((key) => ({
        name: key,
        data: newarr[key],
        color:  newarr[key][0]?.settings?.color || "#000000"
      }));

      console.log(resp.data);
      console.log(formatedData);
      setCoalitions(formatedData);
    } catch (error) {
      console.log(error);
    }
  };

  const getBulletin = async () => {
    try {
      const resp = await axios.get('https://data-ecp.infobae.com/infobae.com/2022/colombia/general/CO_president.json');

      let boletinGeneral =
        resp.data.parties?.find((party) => party.name.toLowerCase() === 'boletín')?.votes ||
        bulletinInitial.bulletinGeneral;
      let mesasTotales =
        resp.data.parties?.find((party) => party.name.toLowerCase() === 'mesas totales')?.votes ||
        bulletinInitial.deskTotal;
      let mesasInformadas =
        resp.data.parties?.find((party) => party.name.toLowerCase() === 'mesas informadas')?.votes ||
        bulletinInitial.deskInformation;
      let mesasEscrutadas =
        resp.data.parties?.find((party) => party.name.toLowerCase() === 'mesas escrutadas')?.votes ||
        bulletinInitial.desckScreened;

      setBulletin({
        bulletinGeneral: new Intl.NumberFormat().format(boletinGeneral),
        deskTotal: new Intl.NumberFormat().format(mesasTotales),
        deskInformation: new Intl.NumberFormat().format(mesasInformadas),
        desckScreened: ((mesasEscrutadas / mesasTotales) * 100).toFixed(2),
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
    getBulletin();
  }, []);

  useEffect(() => {
    const updateInterval = setInterval(() => {
      (async () => {
        getData();
        getBulletin();
      })();
    }, 1000 * 60 * 10);
    return () => clearInterval(updateInterval);
  }, []);

  return (
    <div className="container">
      {lastUpdate && <LastUpdate time={time} />}
      <div className="container__cards">
        {coalitions.map((coal) => (
          <div key={coal.name} className="container__card">
            {coalition && <PoliticalParty name={coal.name} coalition={coal.data} color={coal.color} />}
            {seeMore && <PoliticalCandidate name={coal.name} coalition={coal.data} color={coal.color} />}
          </div>
        ))}
      </div>

      <div className="container__button">
        {showMore && <button onClick={() => setSeeMore(!seeMore)}>{seeMore ? 'VER MENOS' : 'VER MÁS'}</button>}
      </div>

      {stats && <Resume votes={votes} bulletin={bulletin} />}
    </div>
  );
}

export default InforParty;
